import { HugeiconsIcon } from "@hugeicons/react"
import { ArrowLeft01Icon, ArrowRight01Icon } from "@hugeicons/core-free-icons"

interface NavigationButtonsProps {
  showButtons: boolean
  onPrev?: () => void
  onNext?: () => void
}

export function NavigationButtons({
  showButtons,
  onPrev,
  onNext,
}: NavigationButtonsProps) {
  if (!showButtons) return null

  return (
    <>
      <button
        onClick={onNext}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 size-10 bg-white rounded-sm flex items-center justify-center shadow-[-4px_4px_4px_0px_#00000040] transition-all text-primary-500 cursor-pointer hover:bg-gray-50"
        aria-label="Next image"
      >
        <HugeiconsIcon icon={ArrowLeft01Icon} strokeWidth={2.5} />
      </button>

      <button
        onClick={onPrev}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 size-10 bg-white rounded-sm flex items-center justify-center shadow-[-4px_4px_4px_0px_#00000040] transition-all text-primary-500 cursor-pointer hover:bg-gray-50"
        aria-label="Previous image"
      >
        <HugeiconsIcon icon={ArrowRight01Icon} strokeWidth={2.5} />
      </button>
    </>
  )
}
